<style lang="less" scoped src="../../components/viewer/css/common.less"></style>
<style lang="less" scoped>
    .sub-item {
        position: relative;
        padding-top: 10px;
        .sub-item-index {
            position: absolute;
            top: 1px;
            left: -20px;
            bottom: 1px;
            width: 26px;
            background: #f5f5f5;
            display: flex;
            align-items:center;
            justify-content:center;
            font-size: 18px;
            font-weight: bold;
        }
    }
</style>
<template>
    <div>
        <div class="sub-item" v-for="(sub_item, index) in item[list_key]" :key="index" v-if="sub_item.status === 1">
            <div class="sub-item-index">{{index + 1}}</div>
            <div v-if="!is_tmall">
                <div class="label">子类名称</div>
                <div class="value">{{sub_item.title}}</div>
            </div>
            <div v-if="is_tmall">
                <div class="label">宝贝标题</div>
                <div class="value">{{sub_item.tmall_title}}</div>
            </div>
            <Row class="line" :gutter="4">
                <i-col span="9">
                    <div class="label">内部编码</div>
                    <div class="value">{{sub_item.inner_name}}</div>
                </i-col>
                <i-col span="8">
                    <div class="label">单价</div>
                    <div class="value">{{$util.formatPrice(sub_item.price)}}</div>
                </i-col>
            </Row>
            <div v-if="show_url_image">
                <div class="label">子类图片</div>
                <div class="value">
                    <div class="image-wrapper" v-if="sub_item.url_image">
                        <img :src="mallFileUrl(sub_item.url_image)" alt="">
                    </div>
                </div>
            </div>
            <div v-if="isBook(sub_item)">
                <Row class="line" :gutter="4">
                    <i-col span="9">
                        <div class="label">书名</div>
                        <div class="value">{{sub_item.book_name}}</div>
                    </i-col>
                    <i-col span="8">
                        <div class="label">ISBN</div>
                        <div class="value">{{sub_item.book_isbn}}</div>
                    </i-col>

                </Row>
                <Row class="line" :gutter="4">
                    <i-col span="9">
                        <div class="label">作者</div>
                        <div class="value">{{sub_item.book_author}}</div>
                    </i-col>
                    <i-col span="8">
                        <div class="label">出版社</div>
                        <div class="value">{{sub_item.book_publisher}}</div>
                    </i-col>
                </Row>
                <Row class="line" :gutter="4">
                    <i-col span="9">
                        <div class="label">是否套装</div>
                        <div class="value">{{sub_item.book_suit ? '是' : '否'}}</div>
                    </i-col>
                    <i-col span="8">
                        <div class="label">一号多书</div>
                        <div class="value">{{sub_item.book_multi ? '是' : '否'}}</div>
                    </i-col>
                </Row>
                <div class="line" >
                    <div class="label">包装正面图</div>
                    <div class="value">
                        <MallImage :src="sub_item.book_front_image" v-if="sub_item.book_front_image"></MallImage>
                        <span v-else>-</span>
                    </div>
                </div>
                <div class="line" >
                    <div class="label">条形码特写</div>
                    <div class="value">
                        <MallImage :src="sub_item.book_barcode_image" v-if="sub_item.book_barcode_image"></MallImage>
                        <span v-else>-</span>
                    </div>
                </div>
                <div class="line" >
                    <div class="label">版权页图片</div>
                    <div class="value">
                        <MallImage :src="sub_item.book_copyright_image" v-if="sub_item.book_copyright_image"></MallImage>
                        <span v-else>-</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Util from '../libs/util';
    import FileUploader from '../../components/file/uploader';
    import OnlineStockSelector from '../../stock/components/online_stock_selector';
    import MallImage from './mall_image';

    export default {
        components: { FileUploader, OnlineStockSelector, MallImage },
        props: {
            item: {
                type: Object,
                required: true
            },
            list_key: {
                type: String,
                required: true
            }
        },
        data(){
            return {
                //
            }
        },
        computed: {
            cur_customer() {
                return this.$store.state.cur_customer;
            },
            platform_need_book_info() {
                return ['taobao_sub_items', 'tmall_sub_items'].includes(this.list_key);
            },
            in_group_stock() {
                return this.cur_customer.groups.indexOf('GROUP_STOCK') > -1;
            },
            show_url_image() {
                return 'mall_sub_items' === this.list_key && this.in_group_stock;
            },
            is_tmall() {
                return 'tmall_sub_items' === this.list_key;
            }
        },
        watch: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            isFirst(index) {
                return index === 0;
            },
            isLast(index) {
                return index === this.item[this.list_key].length - 1
            },
            isBook(sub_item) {
                return this.platform_need_book_info && sub_item.stock_group === '01';
            },
            setInnerName(sub_item, inner_name, group, barcode) {
                sub_item.inner_name = inner_name;
                sub_item.stock_group = group;
                if (group === '01') {
                    sub_item.book_isbn = barcode;
                }
            },
            validatePrice(rule, value, callback){
                if(!this.$util.isNumber(value)){
                    callback(new Error('格式有误, 请输入正确的金额'));
                }else if(math.eval(`${value} <= 0`)){
                    callback(new Error('金额必须大于0'));
                }else{
                    callback();
                }
            },
            validateSubItems(rule, sub_items, callback) {
                const platform_need_book_info = ['taobao_sub_items', 'tmall_sub_items'].includes(rule.field);
                let err_msg = '';
                sub_items.forEach((sub_item, index) => {
                    if (!sub_item.inner_name) {
                        err_msg += `[子项${index+1} 请选择内部编码] `;
                    }
                    if (!sub_item.title) {
                        err_msg += `[子项${index+1} 请填写名称] `;
                    }
                    if (!sub_item.price) {
                        err_msg += `[子项${index+1} 请填写单价] `;
                    } else if (!this.$util.isNumber(sub_item.price)) {
                        err_msg += `[子项${index+1} 请填写正确单价格式] `;
                    }
                    const is_book = sub_item.stock_group === '01';
                    if (platform_need_book_info && is_book) {

                    }
                });
                if(err_msg){
                    callback(new Error(err_msg));
                }else{
                    callback();
                }
            },
            uploadImage(sub_item, key, res) {
                sub_item[key] = res.data.path;
            },
            delSubItemImage(sub_item) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '你确实要清除图片吗?',
                    onOk: () => {
                        sub_item.url_image = '';
                    }
                })
            },
            addSubItem() {
                this.$set(this.item[this.list_key], this.item[this.list_key].length, this.$util.clone(Util.new_mall_online_sub_item));
            },
            delSubItem(sub_item, index) {
                if (sub_item.id) {
                    sub_item.status = 0;
                } else {
                    this.item[this.list_key].splice(index, 1);
                }
            },
            mallFileUrl(path) {
                return this.$util.mallFileUrl(path);
            },
        }
    }
</script>
